export default "__VITE_ASSET__CFSP7jqr__"